import { useEffect, useState } from 'react';
import chatblkIcon from '../../../../../../assets/icons/chatblk.svg?raw';
import chatblkLogo from '../../../../../../assets/icons/chatblk-beta.svg?raw';
import chatblkSparkle from '../../../../../../assets/icons/sparkle.svg?raw';
import { joinString } from '../../../../../../_helpers/join-string';
import { ChatBlkButton } from '../../../../../../components/blackrock/advisor-center/_types/header';
import ChatblkTokenIframe from './ChatblkTokenIframe';
import { chatblkConfig } from './ChatblkConfigUtility';

import './ChatBlkIcon.scss';

type ChatBlkEventDetail = {
	action: 'close' | 'open';
	summarize?: boolean;
	relatedQuestion?: string;
};

export const CHATBLK_TOGGLE_EVENT = 'chatblktoggle';

export function ChatBLKIcon({
	dataLinkEvent,
	label,
	dataLinkEventFab,
	labelFab,
	labelCoachmarkTitle,
	labelCoachmarkBody,
	dataLinkEventCoachmarkDismiss,
	labelCoachmarkDismiss,
}: ChatBlkButton) {
	const [open, setOpen] = useState(false);
	const [showSideButton, setShowSideButton] = useState(false);
	const [isFirstLoad, setIsFirstLoad] = useState(true);
	const [shouldHideButton, setShouldHideButton] = useState(false);
	const [showCoachmark, setShowCoachmark] = useState(() => {
		return localStorage.getItem('chatblk_ac_coachmark') !== 'true';
	});
	const handleDismissCoachmark = () => {
		setShowCoachmark(false);
		localStorage.setItem('chatblk_ac_coachmark', 'true');
	};
	useEffect(() => {
		chatblkConfig.getDomainConfig();
		chatblkConfig.getLoginPageUrl();
	}, []);

	const iframeSrc = chatblkConfig.getLoginPageUrl();

	useEffect(() => {
		const animationTimeout = setTimeout(() => {
			setIsFirstLoad(false);

			if (shouldHideButton) {
				setShowSideButton(false);
			} else {
				setShowSideButton(true);
			}
		}, 2400);

		return () => clearTimeout(animationTimeout);
	}, [shouldHideButton]);

	function onClick() {
		window.dispatchEvent(
			new CustomEvent<ChatBlkEventDetail>(CHATBLK_TOGGLE_EVENT, {
				detail: { action: open ? 'close' : 'open' },
			})
		);
	}

	function onSideButtonClick() {
		if (isFirstLoad) {
			setShouldHideButton(true);
		} else {
			setShowSideButton(false);
		}

		window.dispatchEvent(
			new CustomEvent<ChatBlkEventDetail>(CHATBLK_TOGGLE_EVENT, {
				detail: { action: 'open' },
			})
		);
		setShowCoachmark(false);
	}

	// Listen for toggle events
	useEffect(() => {
		function toggleEvent(e: Event) {
			if (isChatBlkToggleEventWithDetail(e)) {
				const isOpening = e.detail.action === 'open';
				setOpen(isOpening);

				if (isOpening) {
					setShowSideButton(false);
				} else {
					setTimeout(() => setShowSideButton(true), 500);
				}
			}
		}

		window.addEventListener(CHATBLK_TOGGLE_EVENT, toggleEvent);

		return () => {
			window.removeEventListener(CHATBLK_TOGGLE_EVENT, toggleEvent);
		};
	}, []);

	return (
		<>
			{/* Overlay */}
			{showCoachmark && (
				<div
					className="blk-ac-chatblk-overlay"
					onClick={handleDismissCoachmark}
				></div>
			)}

			<button
				data-link-event={dataLinkEvent}
				aria-label={label}
				onClick={onClick}
				aria-pressed={open}
				className={joinString([
					'blk-ac-chatblk-icon-container',
					'blk-ac-chatblk-hidden-button',
					open ? 'open' : '',
				])}
				dangerouslySetInnerHTML={{ __html: chatblkIcon }}
			></button>

			<div
				className={joinString([
					'blk-ac-chatblk-side-container',
					showSideButton ? 'show' : '',
					isFirstLoad ? 'animate-on-load' : '',
				])}
			>
				<div className="blk-ac-chatblk-coachmark-wrapper">
					<button
						data-link-event={dataLinkEventFab}
						aria-label={labelFab}
						aria-pressed={open}
						onClick={onSideButtonClick}
						className="blk-ac-chatblk-button"
					>
						<span
							className="blk-ac-chatblk-icon"
							dangerouslySetInnerHTML={{ __html: chatblkSparkle }}
						/>
						<span
							className="blk-ac-chatblk-logo"
							dangerouslySetInnerHTML={{ __html: chatblkLogo }}
						/>
						<span className="blk-ac-chatblk-tm">TM</span>
					</button>

					{/* Coachmark */}
					{showCoachmark && showSideButton && (
						<div className="blk-ac-chatblk-coachmark">
							<div className="blk-ac-chatblk-coachmark-content">
								<div className="blk-ac-chatblk-coachmark-title oneds-blk-heading-xxl">
									{labelCoachmarkTitle}
								</div>
								<div className="blk-ac-chatblk-coachmark-description oneds-blk-body-xl">
									{labelCoachmarkBody}
								</div>
								<button
									data-link-event={dataLinkEventCoachmarkDismiss}
									aria-label={labelCoachmarkDismiss}
									className="blk-ac-chatblk-coachmark-dismiss oneds-blk-heading-s"
									onClick={handleDismissCoachmark}
								>
									{labelCoachmarkDismiss}
								</button>
							</div>
						</div>
					)}
				</div>
			</div>

			<ChatblkTokenIframe iframeSrc={iframeSrc} />
		</>
	);
}

function isChatBlkToggleEventWithDetail(
	e: Event
): e is CustomEvent<ChatBlkEventDetail> {
	return (
		typeof (e as CustomEvent).detail?.action === 'string' &&
		['close', 'open'].includes((e as CustomEvent).detail.action)
	);
}
